import * as React from 'react';
import { CartItem, CardItemComponent } from '@weddingspot/ws-core-components';

const styles = require('../CheckOutPage.module.scss');

interface VenuesListProps {
    items: CartItem[];
    name: string;
    removeItem: (id: string | number) => () => void;
    additionalSubtitle?: (item: CartItem) => JSX.Element | null;
}
export const ItemsList = (props: VenuesListProps) => {
    const { items, name, removeItem, additionalSubtitle } = props;

    return (
        <div className={styles.venuesList}>
            <h2>
                {items.length} {name} selected
            </h2>
            {items.map((item: CartItem) => (
                <CardItemComponent
                    id={item.id}
                    title={item.name}
                    subtitle={item.location}
                    key={item.id}
                    rating={item.rating}
                    image={item.imageUrl}
                    additionalSubtitle={additionalSubtitle && additionalSubtitle(item)}
                    onClickRemove={removeItem(item.id)}
                />
            ))}
        </div>
    );
};
